export const zh = {
    "Total": "共",
    "Items": "条",
    "Item": "条"
}